import { Component, Host, h, Event, EventEmitter, State, Prop } from '@stencil/core'
import { UpgradeToManagerUserDocument, UpgradeToManagerUserMutation, UpgradeToManagerUserMutationVariables } from '../../graphql/generated'
import { ApolloClient } from '@apollo/client'

@Component({
  tag: 'snap-sign-in-form',
  styleUrl: 'snap-sign-in-form.scss',
  scoped: true,
})
export class SnapSignInForm {
  apolloClient?: ApolloClient<any>

  @Prop({ reflect: true }) inModal = false
  @Prop({ reflect: true }) selectedTool: string

  @State() schoolOptions = []
  @State() selectedOptions = { school: '', tool: '' }
  @State() nextBtnDisabled = true
  @State() selectedToolName = ''

  @Event({ eventName: 'snap-sign-in-form-closed', bubbles: true, composed: true }) snapSigninFormClosed: EventEmitter<void>

  private client: ApolloClient<any> = null

  private schools = []

  private manageToolOptions = [
    {
      id: "schedules",
      name: 'AD Assist',
      selected: false,
    },
    {
      id: "registration",
      name: 'Registration',
      selected: false,
    },
    {
      id: "sites",
      name: 'Control Panel',
      selected: false,
    },
  ]

  componentWillLoad() {
    this.client = window.__SNAP_APOLLO_CLIENT__
    if (this.client) {
      this.fetchSchools()
    }

    if (this.selectedTool) {
      const toolMap = {
        'manage': 'Snap! Manage',
        'registration': 'Registration',
        'sites': 'Sites',
        'schedules': 'Schedules',
      };

      this.selectedOptions['tool'] = this.selectedTool;
      this.selectedToolName = toolMap[this.selectedTool] ?? '';
      this.enableNextBtn();
    }
  }

  async fetchSchools() {
    try {
      await fetch('https://manage-api.snap.app', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(
          {
            query: "query GetAllSchools($filter: ManageOrganizationFilter){manageOrganizationList(filter: $filter) {list {schoolId schoolName state city path webFolder} count}}",
            variables: {
              filter: {
                where: {
                  show: 1,
                },
                whereNot: [
                  {
                    webFolder: null,
                  },
                  {
                    webFolder: '0',
                  },
                  {
                    webFolder: '',
                  },
                  {
                    state: null,
                  },
                ],
              }
            }
          }),
      })
      .then(response => response.json())
      .then(data => {
        this.schools = data.data.manageOrganizationList.list;
        this.schoolOptions = this.schools.map(item => {
          return {
            name: item.schoolName,
            selected: false,
          }
        })
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    } catch (error) {
      console.log(error)
    }
  }

  schoolSearchUpdated(e) {
    let result = ''

    this.schoolOptions.some(item => {
      if (item.name === e.detail.value.trim()) {
        result = item.name
        return true
      }
    })

    this.selectedOptions['school'] = result
    this.enableNextBtn()
  }

  selectMenuUpdated(e) {
    let result = ''
    e.detail.some(item => {
      if (item.selected) {
        result = item.id
        return true
      }
    })

    this.selectedOptions['tool'] = result
    this.selectedTool = result
    this.enableNextBtn()
  }

  enableNextBtn() {
    let flag = true

    Object.entries(this.selectedOptions).map(item => {
      if (!item[1]) flag = false
    })

    this.nextBtnDisabled = !flag
  }

  async nextBtnClick() {
    if (this.nextBtnDisabled) return

    try {
      const res = await this.client.mutate<UpgradeToManagerUserMutation, UpgradeToManagerUserMutationVariables>({
        mutation: UpgradeToManagerUserDocument,
      })
      console.log(res)
    } catch (e) {
      console.log(e)
    }

    let result = ''
    this.schools.some(item => {
      if (item.schoolName === this.selectedOptions.school) {
        result = item.path
        return true
      }
    })

    if (this.selectedTool === 'registration') {
      window.location.href = `https://manage.snap.app/register/${result}`
    } else if (this.selectedTool === 'schedules') {
      window.location.href = `https://manage.snap.app/ad-assist/${result}`
    } else if (this.selectedTool === 'sites') {
      window.location.href = `https://manage.snap.app/control-panel/${result}`
    } else {
      window.location.href = `https://manage.snap.app/control-panel/`
    }

    this.snapSigninFormClosed.emit()
  }

  onCloseBtnHandler() {
    this.snapSigninFormClosed.emit()
  }

  render() {
    return (
      <Host>
        <div class="sign-in-manage">
          {!this.inModal && <div class="sign-in-manage-backdrop"></div>}
          <div class="sign-in-manage-container">
            <snap-icon
              class="close-icon"
              icon="x-solid"
              size="md"
              color="#64748B"
              onClick={() => {
                this.onCloseBtnHandler()
              }}
            />
            <h1>
              Sign in to <span>{this.selectedToolName}</span>
            </h1>

            <div class="school-search-label">School or Organization</div>
            <snap-search
              _id="snap-search"
              options={this.schoolOptions}
              class="school-search"
              placeholder="e.g., Snapton High"
              onSnap-search-input={e => {
                this.schoolSearchUpdated(e)
              }}
              onSnap-search-change={e => {
                this.schoolSearchUpdated(e)
              }}
            />

            {this.selectedTool === 'manage' && (
              <snap-select-menu
                modal-type="fullscreen"
                selectMenuOptions={this.manageToolOptions}
                label="Snap! Manage Tool"
                modal-title="Snap! Manage Tool"
                placeholder="Select Tool"
                class="select-menu"
                onSnap-select-menu-updated={e => {
                  this.selectMenuUpdated(e)
                }}
              />
            )}

            <div class="sign-in-manage-footer">
              <div class="btn-wrapper">
                <snap-button
                  variant="primary"
                  fullWidth={true}
                  disabled={this.nextBtnDisabled}
                  onClick={() => {
                    this.nextBtnClick()
                  }}>
                  Next
                </snap-button>
              </div>
            </div>
          </div>
        </div>
      </Host>
    )
  }
}
